import { lazy, Suspense } from 'react';

import './App.css';
import './tutorial.css';

// Code splitting na raiz: o iframe do widget (embutido nos sites dos clientes,
// uma carga por visitante por página) e o painel administrativo viram chunks
// separados. Antes, o iframe baixava o bundle inteiro do painel (~730 KB gzip)
// só para renderizar o chat. A decisão é pelo pathname, antes de qualquer
// Router, para que nada do painel entre no grafo de imports do iframe.
const IFRAME_PATH_PREFIX = '/agent-chat/iframe';

const PanelApp = lazy(() => import('./PanelApp'));
const IframeApp = lazy(() => import('./IframeApp'));

const isIframePath = (pathname) =>
  pathname === IFRAME_PATH_PREFIX || pathname.startsWith(IFRAME_PATH_PREFIX + '/');

function App() {
  if (isIframePath(window.location.pathname)) {
    // Fallback vazio: o iframe é transparente sobre o site do cliente até o
    // botão flutuante montar; um fundo preto aqui apareceria como um quadrado.
    return (
      <Suspense fallback={null}>
        <IframeApp />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<div className="min-h-screen bg-black" />}>
      <PanelApp />
    </Suspense>
  );
}

export default App;

export { config } from './appConfig';
